import styled from 'styled-components';

export const PaymentFormContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 48px;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 8px;
  box-sizing: border-box;
  max-width: 948px;
  padding: 24px;
  width: 100%;
  
  h2 {
    font-size: 32px;
    font-family: 'Roboto Condensed';
    font-weight: 200;
    opacity: 0.4;
    padding-bottom: 16px;
  }
  
  .no-tier-selected {
    text-align: center;
  }
`
export const OrderSummary = styled.div`
    align-items: center;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 420px;    
    width: 100%
`
export const SummaryItem = styled.div`
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      width: 100%;
      
      &.bonus {
        color: #28a745;
        font-weight: bold;
      }
`
export const SummaryTotal = styled.div`
      display: flex;
      justify-content: space-between;
      font-weight: bold;
      font-size: 1.1rem;
      border-top: 1px solid #dee2e6;
      padding-top: 10px;
      margin-top: 10px;
      width: 100%;
`
 
export const CardElementContainer = styled.div`
  width: 100%;
  min-width: 420px;
  min-height: 48px;
  padding: 16px 16px;
  border-radius: 6px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
  background-color: rgba(255, 255, 255, 1.0);
`;
export const CardError = styled.p`
    color: #dc3545;
    font-size: 16px;
    width: 100%;
    text-align: center;
`
export const PayButton = styled.button`
    width: 100%;
    background: #28a745;
    color: white;
    border: none;
    padding: 15px;
    border-radius: 6px;
    font-size: 1.1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background 0.3s ease;
    
    &:hover:not(:disabled) {
      background: #218838;
    }
    
    &:disabled {
      background: #6c757d;
      cursor: not-allowed;
    }
`; 